import React, { useState, useEffect } from "react";
import HeaderBar from "../components/HeaderBar";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";

import {
  materialRenderers,
  materialCells,
} from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import Breadcrumbs from "../components/Breadcrumbs";

const NewUserForm = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const hardwareRule = {
    effect: "DISABLE",
    condition: {
      scope: "#/properties/hardware",
      schema: {
        not: {
          contains: { const: "yes" },
        },
      },
    },
  };

  const schema = {
    type: "object",
    properties: {
      newUser: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["yes"],
        },
      },
      firstName: {
        type: "string",
        title: "First name",
      },
      lastName: {
        type: "string",
        title: "Last name",
      },
      email: {
        type: "string",
        title: "Email",
        format: "email",
      },
      cellPhone: {
        type: "number",
        pattern: "^[0-9]{10,}$",
        title: "Cell-phone",
      },
      phone: {
        type: "number",
        title: "Phone",
      },
      accountType: {
        type: "string",
        oneOf: [
          {
            const: "AT1",
            title: "Account Type 1",            
          },
          {
            const: "AT2",
            title: "Account Type 2",
          },
          {
            const: "AT3",
            title: "Account Type 3",
          },
          {
            const: "AT4",
            title: "Account Type 4",
          },
        ],
      },
      price: {
        type: "number",
        title: "Price",
      },
      license: {
        type: "string",
        oneOf: [
          {
            const: "l1",
            title: "License 1",
          },
          {
            const: "L2",
            title: "License 2",
          },
          {
            const: "L3",
            title: "License 3",
          },
          {
            const: "L4",
            title: "License 4",
          },
        ],
      },
      ad: {
        type: "string",
        title: "AD",
      },
      office: {
        type: "string",
        oneOf: [
          {
            const: "angelholm",
            title: "Angelholm",
          },
          {
            const: "gotemburg",
            title: "Gotemburg",
          },
        ],
      },

      department: {
        type: "string",
        oneOf: [
          {
            const: "economy",
            title: "Economy",
          },
          {
            const: "marketing",
            title: "Marketing",
          },
          {
            const: "sales",
            title: "Sales",
          },
          {
            const: "support",
            title: "Support",
          },
        ],
      },

      manager: {
        type: "string",
        oneOf: [
          {
            const: "peter",
            title: "Pete",
          },
          {
            const: "sarah",
            title: "Sarah",
          },
          {
            const: "dan",
            title: "Dan",
          },
          {
            const: "lisa",
            title: "Lisa",
          },
        ],
      },

      copyUser: {
        type: "string",
        oneOf: [
          {
            const: "a",
            title: "A",
          },
          {
            const: "b",
            title: "B",
          },
          {
            const: "c",
            title: "C",
          },
          {
            const: "d",
            title: "D",
          },
        ],
      },
      ADgroups: {
        type: "string",
        enum: ["Group 1", "Group 2", "Group 3"],
      },
      useExistingComputer: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["yes"],
        },
      },
      location: {
        type: "string",
        title: "Location",
      },
      details: {
        type: "string",
        title: "Details",
      },
      hardware: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["yes"],
        },
      },
      toWhom: {
        type: "string",
        oneOf: [
          {
            const: "a",
            title: "A",
          },
          {
            const: "b",
            title: "B",
          },
          {
            const: "c",
            title: "C",
          },
          {
            const: "d",
            title: "D",
          },
        ],
      },
      desiredDelivery: {
        properties: {
          desiredDeliveryDate: {
            type: "string",
            format: "date",
            description: "Schema-based date picker",
          },
        },
      },
      billingGroup: {
        type: "string",
        oneOf: [
          {
            const: "b1",
            title: "B1",
          },
          {
            const: "b2",
            title: "B2",
          },
          {
            const: "b3",
            title: "B3",
          },
          {
            const: "b4",
            title: "B4",
          },
        ],
      },
      deliveryAddress: {
        type: "string",
        title: "Delivery address",
      },
      laptop: {
        properties: {
          laptop: {
            type: "string",
            enum: ["Standard laptop 1", "Standard laptop 2"],
          },
        },
      },
      monitor: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["yes"],
        },
      },
      keyboard: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["yes"],
        },
      },
      IntunePrograms: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["Microsoft 365", "Teams", "OneDrive", "Other"],
        },
      },
      ManualPrograms: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["AutoCad", "SolidWorks", "Office", "Other"],
        },
      },
      comments: {
        type: "object",
        properties: {
          comments: { type: "string", title: "Comments" },
        },
      },
    },
    required: [
      "firstName",
      "email",
      "accountType",
      "price",
      "license",
      "ad",
      "manager",
      "toWhom",
      "desiredDelivery",
      "billingGroup",
      "deliveryAddress",
    ],
  };

  const uischema = {
    type: "HorizontalLayout",
    elements: [
      {
        type: "Group",
        label: "Person",
        elements: [
          {
            type: "VerticalLayout",
            elements: [
              {
                type: "Control",
                scope: "#/properties/newUser",
              },
              {
                type: "Control",
                scope: "#/properties/firstName",
              },
              {
                type: "Control",
                scope: "#/properties/lastName",
              },
              {
                type: "Control",
                scope: "#/properties/email",
              },
              {
                type: "Control",
                scope: "#/properties/cellPhone",
              },
              {
                type: "Control",
                scope: "#/properties/phone",
              },
              {
                type: "Control",
                scope: "#/properties/accountType",
              },
              {
                type: "Control",
                scope: "#/properties/price",
              },
              {
                type: "Control",
                scope: "#/properties/license",
              },
              {
                type: "Control",
                scope: "#/properties/ad",
              },
              {
                type: "Control",
                scope: "#/properties/office",
              },
              {
                type: "Control",
                scope: "#/properties/department",
              },
              {
                type: "Control",
                scope: "#/properties/manager",
              },
              {
                type: "Control",
                scope: "#/properties/copyUser",
              },
              {
                type: "Control",
                scope: "#/properties/ADgroups",
              },
              {
                type: "Control",
                scope: "#/properties/useExistingComputer",
              },
              {
                type: "Control",
                scope: "#/properties/location",
              },
              {
                type: "Control",
                scope: "#/properties/details",
              },
            ],
          },
        ],
      },
      {
        type: "Group",
        label: " ",
        elements: [
          {
            type: "VerticalLayout",
            elements: [
              {
                type: "Control",
                scope: "#/properties/hardware",
              },
              {
                type: "Control",
                scope: "#/properties/toWhom",
              },
              {
                type: "Control",
                scope: "#/properties/desiredDelivery",
              },
              {
                type: "Control",
                scope: "#/properties/billingGroup",
              },
              {
                type: "Control",
                scope: "#/properties/deliveryAddress",
              },
              {
                type: "Control",
                scope: "#/properties/laptop/properties/laptop",
                rule: hardwareRule,
              },
              {
                type: "Control",
                scope: "#/properties/monitor",
              },
              {
                type: "Control",
                scope: "#/properties/keyboard",
              },
              {
                type: "Control",
                scope: "#/properties/IntunePrograms",
              },
              {
                type: "Control",
                scope: "#/properties/ManualPrograms",
              },
              {
                type: "VerticalLayout",
                elements: [
                  {
                    type: "Control",
                    scope: "#/properties/comments/properties/comments",
                    options: {
                      multi: true,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };

  const dynamicUiSchema = {
    ...uischema,
    elements: uischema.elements.map((group) => {
      return {
        ...group,
        elements: group.elements.map((section) => {
          if (section.type === "VerticalLayout" || section.type === "Group") {
            return {
              ...section,
              elements: section.elements.map((control) => {
                if (
                  control.scope === "#/properties/monitor" ||
                  control.scope === "#/properties/keyboard" ||
                  control.scope === "#/properties/laptop/properties/laptop" ||
                  control.scope === "#/properties/IntunePrograms" ||
                  control.scope === "#/properties/ManualPrograms"
                ) {
                  return {
                    ...control,
                    rule: hardwareRule,
                  };
                }

                return control;
              }),
            };
          }
          return section;
        }),
      };
    }),
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create User</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBackClick}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled="{/* !hasChanges */}"
                  onClick="{handleCreateUser}"
                >
                  Save user
                </button>
              </div>
            </div>
            <JsonForms
              schema={schema}
              uischema={dynamicUiSchema}
              data={data}
              renderers={materialRenderers}
              cells={materialCells}
              onChange={({ data }) => setData(data)}
            />
          </div>
        </main>
      </div>
    </>
  );
};

export default NewUserForm;
